import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { getAllFeatures, getAllPlans, getPlanSubscriberUserListAction, setAllFeatures, setAllPlans, setPlanSubscriberUserListAction, updatePlanError, updatePlanResponse, updatePlans, updateSinglePlanAction } from "../reducers/servicePlansSlice";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";


/**
 * This function for call the user profile
 *
 * @param {*} payload
 */
function* getAllPlansSaga():any {
    yield put(setLoaderAction(true))
    console.log('plans-try')
    try {
        const plans = yield call<any>(callAPI, {}, 'get', 'plans/all')
        console.log('plans-', plans)
        if(plans?.data){
            yield put(setAllPlans(plans?.data))
        }
    } catch (error) {
        console.log('Catch Error-', error)
    }
    yield put(setLoaderAction(false))
}

function* getAllFeaturesSaga():any {
    yield put(setLoaderAction(true))
    try {
        const features = yield call<any>(callAPI, {}, 'get', 'features')
        console.log('features-', features)
        if(features?.data){
            yield put(setAllFeatures(features?.data))
        }
    } catch (error) {
        console.log('Catch Error-', error)
    }
    yield put(setLoaderAction(false))
}



function* updatePlansSaga(payload: any[]):any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
    try {
        const apiResponse = yield call<any>(callAPI, payload, 'post', 'plans/create')
        console.log('apiResponse-', apiResponse)
        if(apiResponse?.success === true){
          apiResponse && handleSuccess(apiResponse);
            yield put(updatePlanResponse(true));
            yield put(updatePlanError(false));
        }
    } catch (error:any) {
        console.log('Catch Error-', error);
        error?.response && handleError(error?.response?.data)
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(updatePlanError(true));
        yield put(updatePlanResponse(false));
    }
    yield put(setLoaderAction(false));
}

function* updateSinglePlanSaga(payload: any[]):any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
    try {
        const apiResponse = yield call<any>(callAPI, payload, 'put', 'plans/update/')
        console.log('apiResponse-', apiResponse)
        if(apiResponse?.success === true){
          apiResponse && handleSuccess(apiResponse);
            yield put(updatePlanResponse(true));
            yield put(updatePlanError(false));
        }
    } catch (error:any) {
        console.log('Catch Error-', error);
        error?.response && handleError(error?.response?.data)
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(updatePlanError(true));
        yield put(updatePlanResponse(false));
    }
    yield put(setLoaderAction(false));
}

function* getPlanSubscriberUserListSaga(action: any): any {
    yield put(setLoaderAction(true));
    yield put(setNotificationAction({ message: [], severity: "error" }));
    try {
      const planId = action.payload; // Directly access the payload
      console.log("planId", planId);
      const apiResponse = yield call<any>(
        callAPI,
        {},
        "get",
        `plans/${planId}/tenants`
      );
      console.log("apiResponse-", apiResponse);
      if (apiResponse?.success === true) {
        // apiResponse && handleSuccess(apiResponse);
        yield put(setPlanSubscriberUserListAction(apiResponse?.data));
      }
    } catch (error: any) {
      console.log("Catch Error-", error);
     
    }
    yield put(setLoaderAction(false));
  }


export function* watchPlan() {
    yield takeLatest<any>(getAllPlans, getAllPlansSaga);
    yield takeLatest<any>(getAllFeatures, getAllFeaturesSaga);
    yield takeLatest<any>(updatePlans, updatePlansSaga);
    yield takeLatest<any>(getPlanSubscriberUserListAction, getPlanSubscriberUserListSaga);
    yield takeLatest<any>(updateSinglePlanAction,updateSinglePlanSaga);
}